import { render, staticRenderFns } from "./LoginChange.vue?vue&type=template&id=6ac0d08a&"
import script from "./LoginChange.vue?vue&type=script&lang=js&"
export * from "./LoginChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports